(() => {
  class StudioProductGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.previousButton = this.querySelector('[data-gallery-previous]');
      this.nextButton = this.querySelector('[data-gallery-next]');
      this.counter = this.querySelector('[data-gallery-counter]');
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));

      this.previousButton?.addEventListener('click', () => this.show(this.index - 1));
      this.nextButton?.addEventListener('click', () => this.show(this.index + 1));

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.show(this.index - 1);
        if (event.key === 'ArrowRight') this.show(this.index + 1);
      });

      this.touchStartX = null;
      this.addEventListener('touchstart', (event) => {
        this.touchStartX = event.touches[0]?.clientX ?? null;
      }, { passive: true });
      this.addEventListener('touchend', (event) => {
        if (this.touchStartX === null) return;
        const endX = event.changedTouches[0]?.clientX ?? this.touchStartX;
        const distance = endX - this.touchStartX;
        this.touchStartX = null;
        if (Math.abs(distance) < 45) return;
        this.show(distance > 0 ? this.index - 1 : this.index + 1);
      }, { passive: true });

      this.show(this.index, false);
    }

    show(requestedIndex, focus = true) {
      if (!this.slides.length) return;
      this.index = (requestedIndex + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });

      if (this.counter) this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
      if (focus) this.slides[this.index]?.querySelector('img')?.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('studio-product-gallery')) {
    customElements.define('studio-product-gallery', StudioProductGallery);
  }
})();
